import React from "react";
import { WalletOutlined, DollarCircleOutlined } from "@ant-design/icons";
import { useAppStore } from "../../store";
import { formatCurrency } from "../../utils";
import Earned from "../../components/sections/earned";
import Payouts from "../../components/sections/payouts";

export default function Transactions() {
  const { doctor } = useAppStore();

  return (
    <div className="min-h-[70vh] bg-[#f8fafc]">
      <header className="mb-6">
        <h1 className="text-3xl font-bold text-medpharma-slate tracking-tight m-0">
          Transactions
        </h1>
        <p className="mt-1 text-sm text-slate-500">
          Track what you've earned and what's already been paid out.
        </p>
      </header>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 mb-6">
        <div className="bg-white rounded-2xl border border-slate-200/80 shadow-card-hover p-6">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-slate-100 text-slate-500">
              <WalletOutlined className="text-lg" />
            </div>
            <p className="m-0 text-sm font-medium text-slate-500">Total Earnings</p>
          </div>
          <p className="mt-4 mb-0 text-3xl font-bold text-slate-900">
            {formatCurrency(doctor?.totalEarned)}
          </p>
          <p className="mt-2 mb-0 text-sm text-slate-400">
            Your all-time earnings with Medpharma.
          </p>
        </div>

        <div className="bg-white rounded-2xl border border-primary/20 shadow-card-hover p-6">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
              <DollarCircleOutlined className="text-lg" />
            </div>
            <p className="m-0 text-sm font-medium text-slate-500">Available Earnings</p>
          </div>
          <p className="mt-4 mb-0 text-3xl font-bold text-primary-blue">
            {formatCurrency(doctor?.balance)}
          </p>
          <p className="mt-2 mb-0 text-sm text-slate-400">
            Payments are done weekly, every Monday.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <Earned />
        <Payouts />
      </div>
    </div>
  );
}
